import { PropTypes } from 'prop-types'
import { Element } from '../../../../../../common/html/element'
import { Icon } from '../../../../../../common/html/icon'
import classes from './index.module.scss'

export const DeleteAddButtons = ({
  showAddBtn,
  showDeleteBtn,
  onAddBtnClick,
  onDeleteBtnClick,
}) => {
  return (
    <Element className={classes.buttons}>
      <Element
        className={classes.verticalLine}
        style={{ backgroundColor: '#D5D5D5' }}
      />
      <Element
        className={`${classes.iconDelete} ${
          !showDeleteBtn ? classes.hidden : ''
        }`}
        onClick={onDeleteBtnClick}
      >
        <Icon
          className="icon-delete-circle-fill"
          style={{ fontSize: 16, color: '#9C9C9C' }}
        />
      </Element>
      <Element
        className={`${classes.iconPlus} ${!showAddBtn ? classes.hidden : ''}`}
        onClick={onAddBtnClick}
      >
        <Icon
          className="icon-plus-circle-fill"
          style={{ fontSize: 16, color: '#2C73E8' }}
        />
      </Element>
    </Element>
  )
}

DeleteAddButtons.propTypes = {
  showAddBtn: PropTypes.bool,
  showDeleteBtn: PropTypes.bool,
}

DeleteAddButtons.defaultProps = {
  showAddBtn: false,
  showDeleteBtn: true,
}
